import React from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';

const Hero = () => {
  const heroStyle = {
    backgroundImage: "url('/images/products/bg.JPG')",
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  };

  return (
    <section className="hero" style={heroStyle}>
      <div className="hero-overlay"></div>
      <div className="container hero-container">
        <div className="hero-content">
          <h1 className="hero-title">
            <span className="highlight">Precision</span> Engineering for
            <span className="highlight"> Industrial Excellence</span>
          </h1>
          <p className="hero-description">
            Global Business Combine (GBC) is your trusted partner for high-quality tungsten carbide dies, 
            diamond tools, and abrasives. With over three decades of experience and ISO 9001-2008 certification, 
            we deliver precision-engineered solutions for industries worldwide.
          </p>
          <div className="hero-buttons">
            <Link to="/products" className="btn hero-btn primary">
              Explore Our Products
            </Link>
            <Link to="/contact" className="btn hero-btn secondary">
              Request a Consultation
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
